"use strict";
/**
 * CandyShopInfoAPI provides a gateway for callers to interact with CandyShop APIs without going through
 * CandyShop instance but just a few required fields from CandyShop instance to get the shop info.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchCollectionByShopAddress = exports.fetchAllCollection = exports.fetchAllShop = exports.fetchShopStatusByShopAddress = exports.fetchShopByShopAddress = exports.fetchOrderByShopAndMintAddress = exports.fetchShopWhitelistNftByShopAddress = exports.fetchOrdersByShopAndMasterEditionMint = exports.fetchOrdersByShopAndWalletAddress = exports.fetchOrdersByShopAddress = exports.fetchNFTByMintAddress = exports.fetchTradeByShopAddress = exports.fetchStatsByShopAddress = void 0;
const backend_1 = require("./factory/backend");
const config_1 = __importDefault(require("./vendor/config"));
function fetchStatsByShopAddress(candyShopAddress) {
    return (0, backend_1.fetchStatsById)(config_1.default, candyShopAddress);
}
exports.fetchStatsByShopAddress = fetchStatsByShopAddress;
function fetchTradeByShopAddress(candyShopAddress, queryDto) {
    return (0, backend_1.fetchTradeById)(config_1.default, candyShopAddress, queryDto);
}
exports.fetchTradeByShopAddress = fetchTradeByShopAddress;
function fetchNFTByMintAddress(mintAddressStr) {
    return (0, backend_1.fetchNftByMint)(config_1.default, mintAddressStr);
}
exports.fetchNFTByMintAddress = fetchNFTByMintAddress;
function fetchOrdersByShopAddress(candyShopAddress, ordersFilterQuery) {
    return (0, backend_1.fetchOrdersByStoreId)(config_1.default, candyShopAddress, ordersFilterQuery);
}
exports.fetchOrdersByShopAddress = fetchOrdersByShopAddress;
function fetchOrdersByShopAndWalletAddress(candyShopAddress, walletAddressStr) {
    return (0, backend_1.fetchOrdersByStoreIdAndWalletAddress)(config_1.default, candyShopAddress, walletAddressStr);
}
exports.fetchOrdersByShopAndWalletAddress = fetchOrdersByShopAndWalletAddress;
function fetchOrdersByShopAndMasterEditionMint(candyShopAddress, masterMint, ordersEditionFilterQuery) {
    return (0, backend_1.fetchOrdersByStoreIdAndMasterEditionMint)(config_1.default, candyShopAddress, masterMint, ordersEditionFilterQuery);
}
exports.fetchOrdersByShopAndMasterEditionMint = fetchOrdersByShopAndMasterEditionMint;
function fetchShopWhitelistNftByShopAddress(candyShopAddress) {
    return (0, backend_1.fetchShopWhitelistNftByShopId)(config_1.default, candyShopAddress);
}
exports.fetchShopWhitelistNftByShopAddress = fetchShopWhitelistNftByShopAddress;
function fetchOrderByShopAndMintAddress(candyShopAddress, mintAddressStr) {
    return (0, backend_1.fetchOrderByTokenMintAndShopId)(config_1.default, mintAddressStr, candyShopAddress);
}
exports.fetchOrderByShopAndMintAddress = fetchOrderByShopAndMintAddress;
function fetchShopByShopAddress(candyShopAddress) {
    return (0, backend_1.fetchShopByShopId)(config_1.default, candyShopAddress);
}
exports.fetchShopByShopAddress = fetchShopByShopAddress;
function fetchShopStatusByShopAddress(candyShopAddress, query) {
    return (0, backend_1.fetchShopStatusByShopId)(config_1.default, candyShopAddress, query);
}
exports.fetchShopStatusByShopAddress = fetchShopStatusByShopAddress;
function fetchAllShop(allShopQuery) {
    return (0, backend_1.fetchShop)(config_1.default, allShopQuery);
}
exports.fetchAllShop = fetchAllShop;
function fetchAllCollection(allCollectionQuery) {
    return (0, backend_1.fetchCollection)(config_1.default, allCollectionQuery);
}
exports.fetchAllCollection = fetchAllCollection;
function fetchCollectionByShopAddress(collectionByShopQuery) {
    return (0, backend_1.fetchCollectionByShopId)(config_1.default, collectionByShopQuery);
}
exports.fetchCollectionByShopAddress = fetchCollectionByShopAddress;
